import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Cuenta } from '../interfaces/beans.interface';

@Injectable({
    providedIn: 'root'
})
export class CuentaService {

  url = environment.url + '/cuenta';

  constructor(private http: HttpClient) {}

  get() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/get?id=${ localStorage.getItem('idUsuario') }`, { headers }).pipe( map( data => data));
  }

  getById(idUsuario: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/get?id=${ idUsuario }`, { headers }).pipe( map( data => data));
  }

  isCorrectPassword(password: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/validatePassword?id=${ localStorage.getItem('idUsuario') }&password=${ password }`, { headers }).pipe( map( data => data));
  }

  save(cuenta: Cuenta) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    let body = JSON.stringify(cuenta);

    return this.http.post(`${ this.url }/save?id=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }
}
